
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/presse",
      function () {
        return require("private-next-pages/presse.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/presse"])
      });
    }
  